// extracted by mini-css-extract-plugin
export var tabLabel = "r1NQXzhsSOMQt5gdBZy0";
export var tabLinkActive = "osa1dyypx9ul4grQzznK";
export var tabLinkButton = "pkNvI3jZEIdpKcSvZC79";
export var tabLinkLine = "l4V8FZKPwTczYjk8yBL7";
export var withScroll = "Wbcg8PHcLM1lTgchwKT_";